/**
* DevExpress Dashboard (_docking-layout-settings.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
class DockingLayoutSettings {
}
DockingLayoutSettings.layoutPaddings = 16;
export { DockingLayoutSettings };
